import React from 'react';
import SearchBar from './SearchBar';

import './KpiSearchBar.css';

const KpiSearchBar = ({ onChange }) => {
  return (
    <div className="KpiSearchBarContainer">
      <SearchBar defaultText={'Search'} searchQuery={onChange} autoFocus={true} onClose={true}/>
    </div>
  );
};

export default KpiSearchBar;
